import { render, staticRenderFns } from "./SubmittingMockModal.vue?vue&type=template&id=30ab063f&scoped=true"
import script from "./SubmittingMockModal.vue?vue&type=script&lang=js"
export * from "./SubmittingMockModal.vue?vue&type=script&lang=js"
import style0 from "./SubmittingMockModal.vue?vue&type=style&index=0&id=30ab063f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab063f",
  null
  
)

export default component.exports